if (!customElements.get("overflow-slider")) {
  customElements.define(
    "overflow-slider",
    class OverflowSlider extends SlideshowComponent {
      constructor() {
        super();
        console.log("run constructor");
      }
      connectedCallback() {
        super.connectedCallback();
        // this.setInitialCenter()
        document.addEventListener(
          "DOMContentLoaded",
          () => {
            this.setInitialCenter();
          },
          false,
        );
      }

      getSlideClass() {
        return ".slider__slide";
      }

      setInitialCenter() {
        const slider_width = this.slider.offsetWidth;
        const slides = this.slider.querySelectorAll(".slider__slide");
        const final_slide = slides[slides.length - 1];
        if (!final_slide) return;
        const scrollable_width = final_slide.getBoundingClientRect().right;
        const scroll_center = scrollable_width / 2 - slider_width / 2;

        console.log("run", scroll_center);
        this.slider.scrollLeft = scroll_center;

        super.update();

        this.slider.classList.add("loaded");

        // TODO on some loads not center (looks like there is something loading post center calculation)
      }
    },
  );
}

